import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MessengerService} from '../../messenger/messenger.service';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';
import {Auth, ICredentials} from '../auth.service';

export interface IAlert {
    id: number;
    type: string;
    message: string;
}

@Component({
    selector: 'kkk-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {

    @ViewChild('emailField')
    private _emailField: ElementRef;

    @ViewChild('passwordField')
    private _passwordField: ElementRef;

    public credentials: ICredentials;
    public pending: boolean = false;
    public error: boolean = false;
    public msgs: any[] = [];

    private get next(): string {
        const next = this._route.snapshot.queryParams['n'];
        return next && decodeURIComponent(next) || '/kezdolap';
    }

    constructor(
        private _auth: Auth,
        private _router: Router,
        private _route: ActivatedRoute,
        private _messenger: MessengerService,
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    public ngOnInit(): void {
        this.credentials = {
            email: '',
            password: ''
        };
        if (this._auth.isLoggedIn()) {
            this._router.navigate(['/']);
        }
        this._breadcrumbs.setTitle('Bejelentkezés');
    }

    ngAfterViewInit(): void {
        this._emailField.nativeElement.focus();
    }

    public closeAlert(alert: IAlert) {
        const index: number = this.msgs.indexOf(alert);
        this.msgs.splice(index, 1);
    }

    public doLogin(): void {
        this.error = false;
        if (!this.credentials.email || !this.credentials.password) {
            this.error = true;
            if (!this.credentials.email) {
                this._emailField.nativeElement.focus();
            } else {
                this._passwordField.nativeElement.focus();
            }
            return;
        }
        this.pending = true;
        this._auth.doLogin(this.credentials).subscribe(
            () => this._router.navigateByUrl(this.next),
            (e) => {
                this._messenger.handleError(e);
                this.pending = false;
                this.msgs[0] = {
                    severity: 'danger',
                    summary: 'Hiba!',
                    details: 'Helytelen belépési adatok!'
                };
                this._passwordField.nativeElement.focus();
                this._passwordField.nativeElement.select();
            });
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/login/login.component.ts